import { createI18n } from 'vue-i18n';

import cn from "./zh-CN.json";
import en from "./en-US.json";
import tw from "./zh-TW.json";

const i18n = createI18n({
  /** 默认值 */
  locale: 'tw',
  fallbackLocale: 'tw',
  messages: {
    tw,
    cn,
    en,
  },
  silentTranslationWarn: true,
});

export default i18n;
